import { Flex, Modal, Text, Button } from '@jisr-hr/design-system'
import I18n from 'translations/i18n'
import FAICon from 'components/fontawesome/FAICon'
import { Trans } from 'react-i18next'

import { labels } from 'utils/whitelabel'
import styles from './styles.module.css'

type NotificationsGuideProps = {
  guideContent: JSX.Element
  open: boolean
  onClose: () => void
}

const NotificationsGuide = ({
  open,
  onClose,
  guideContent,
}: NotificationsGuideProps): JSX.Element => (
  <Modal
    isOpen={open}
    onClose={onClose}
    disableCloseOut
    variant="centerDialog"
    width="600px"
    modalContentStyle={{ padding: 24 }}
    modalHeaderClassName={styles.guideModalHeader}
    showCloseButton={false}
    header={
      <Text
        typography="title"
        weight="bold"
        data-testid="notifications_guide_title"
      >
        <Trans
          i18nKey="how_to_receive_notifications"
          components={{
            app_name: labels.translation_name,
          }}
        />
      </Text>
    }
    content={
      <>
        {guideContent}
        <Flex
          justifyEnd
          style={{ gap: 8, paddingTop: 16 }}
        >
          <Button
            size="medium"
            variant="secondary"
            label={I18n.t('close')}
            onClick={onClose}
          />
          <Button
            size="medium"
            label={I18n.t('finish')}
            endIcon={<FAICon icon={['far', 'check']} />}
            onClick={onClose}
            data-testid="finish"
          />
        </Flex>
      </>
    }
  />
)

export default NotificationsGuide
